module.exports = __webpack_public_path__ + "static/img/downchart.0bf5fda9.png";